import { elevation, themeBackgrounds, themeColors } from "@dana/MobiusOverrides/styles/colors";
import Zone from "@insite/client-framework/Components/Zone";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";

import * as React from "react";
import { css } from "styled-components";

export interface FullWidthTileStyle {
    fullWidthByVehicleMainContainer?: GridContainerProps;
    fullWidthByVehicleGridItemWrapper?: GridItemProps;
    headingText?: TypographyPresentationProps;
    descriptionText?: TypographyPresentationProps;
    fullWidthByVehicleGridItemsMainWrapper?: GridItemProps;
}

export const fullWidthTileStyle: FullWidthTileStyle = {
    fullWidthByVehicleMainContainer: {
        isFullWidth: false,
        css: css`
            background-color: ${themeBackgrounds.offWhite};
            margin-bottom: 30px;
            display: flex;

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            padding: 40px 16px;
                        `,
                        css`
                            padding: 64px 24px;
                        `,
                        null,
                        css`
                            padding: 80px 40px;
                        `,
                    ],
                    "min",
                )}
        `,

        offsetCss: css`
            position: relative;

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            gap: 24px;
                        `,
                        null,
                        null,
                        css`
                            flex-wrap: nowrap !important;
                            gap: 32px;
                        `,
                        css`
                            flex-wrap: nowrap !important;
                            gap: 32px;
                        `,
                    ],
                    "min",
                )}
        `,
    },

    fullWidthByVehicleGridItemWrapper: {
        width: 12,
        css: css`
            width: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
        `,
    },

    fullWidthByVehicleGridItemsMainWrapper: {
        width: 12,
        css: css`
            max-width: 620px;
            flex-basis: 620px;
            width: 100%;
            position: relative;
            padding: 0px;
            z-index: 0;

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            max-width: 100%;
                            flex-basis: 100%;
                            padding: 15px;
                        `,
                        css`
                            max-width: 100%;
                            flex-basis: 100%;
                            padding: 15px;
                        `,
                        css`
                            max-width: 100%;
                            flex-basis: 100%;
                            padding: 15px;
                        `,
                        css`
                            max-width: 620px;
                            flex-basis: 620px;
                        `,
                        css`
                            max-width: 620px;
                            flex-basis: 620px;
                        `,
                    ],
                    "min",
                )}
        `,
    },

    headingText: {
        variant: "h1",
        css: css`
            margin-bottom: 16px;
            margin-right: auto;
        `,
    },

    descriptionText: {
        css: css``,
    },
};

const styles = fullWidthTileStyle;

const enum fields {
    heading = "heading",
    description = "description",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.heading]: string;
        [fields.description]: string;
    };
}

export const FullWidthContentBlock = ({ id, fields }: OwnProps) => {
    return (
        <>
            <GridContainer {...styles.fullWidthByVehicleMainContainer}>
                <GridItem {...styles.fullWidthByVehicleGridItemWrapper}>
                    <Typography {...styles.headingText}>{translate(fields.heading)}</Typography>
                    <Typography
                        {...styles.descriptionText}
                        className="text-body-lg"
                        dangerouslySetInnerHTML={{ __html: translate(fields.description) }}
                    />
                </GridItem>

                <GridItem {...styles.fullWidthByVehicleGridItemsMainWrapper}>
                    <Zone zoneName="fullWidthSearchByVehicle" contentId={id}></Zone>
                </GridItem>
            </GridContainer>
        </>
    );
};

const widgetModule: WidgetModule = {
    component: FullWidthContentBlock,
    definition: {
        group: "Common",
        displayName: "Full Width Block With Global Search",
        fieldDefinitions: [
            {
                name: fields.heading,
                editorTemplate: "TextField",
                displayName: "Heading Text",
                defaultValue: "",
                fieldType: "Translatable",
                isRequired: true,
                sortOrder: 0,
            },
            {
                name: fields.description,
                editorTemplate: "RichTextField",
                displayName: "Description Text",
                defaultValue: "",
                fieldType: "Translatable",
                sortOrder: 0,
            },
        ],
    },
};
export default widgetModule;
